import React, { Component } from 'react';
import CheckRcRoRt from './CheckRcRoRt'
import Announcement from './Announcement'
import QuickSearch from './QuickSearch'
import { Row, Col } from 'react-bootstrap/lib'
import { Link } from 'react-router-dom'
class Sidebar extends Component {

  render() {
    return (
        <Row>
          <Col lg={12} md={12} sm={4} xs={12}>
            <Link to="/bedrijven" className="quickSearchHolder">
              <QuickSearch />
            </Link>
          </Col>
          <Col lg={12} md={12} sm={4} xs={12}>
            <CheckRcRoRt/>
          </Col>
          <Col lg={12} md={12} sm={4} xs={12}>
            <Announcement/>
          </Col>
        </Row>
    );
  }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/Sidebar.js